import { render, staticRenderFns } from "./createTabs.vue?vue&type=template&id=aad54b86&scoped=true&"
import script from "./createTabs.vue?vue&type=script&lang=js&"
export * from "./createTabs.vue?vue&type=script&lang=js&"
import style0 from "./createTabs.vue?vue&type=style&index=0&id=aad54b86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aad54b86",
  null
  
)

export default component.exports